import { Injectable } from '@angular/core';

import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

let header = new HttpHeaders();
header = header.set('Content-Type', 'application/json; charset=utf-8');

@Injectable({
  providedIn: 'root'
})



export class RecentactivitiesdashboardService {

  constructor(private httpClient: HttpClient) { }
  baseUrl: string = environment.serviceUrl;

  //getAllRequests(itemsperpage: number, pageno: number): Observable<any[]> {
  //  return this.httpClient.get<any[]>(this.baseUrl + 'api/RecentActiviesDashboardApi/GetAllRequests?pagenumber=' + pageno + '&&itemsperpage=' + itemsperpage);
  //};
  //getAllRequestsCount(): Observable<any[]> {
  //  return this.httpClient.get<any[]>(this.baseUrl + 'api/RecentActiviesDashboardApi/GetAllRequestsCount');
  //};
  getAllRequests(data: string): Observable<any[]> {

    return this.httpClient.get<any[]>(this.baseUrl + 'api/RecentActiviesDashboardApi/GetAllRequests/' + data);
  };
  getAllRequestsCount(data: string): Observable<any[]> {
    return this.httpClient.get<any[]>(this.baseUrl + 'api/RecentActiviesDashboardApi/GetAllRequestsCount/' + data);
  };


  getRequestById(requestid: number, requesttypeid: number): Observable<any[]> {
    return this.httpClient.get<any[]>(this.baseUrl +
      'api/RecentActiviesDashboardApi/GetRequestById?requestid=' + requestid + '&&requesttypeid=' + requesttypeid);
  };
  getdocumentRecentActivities(data: string, itemsperpage: number, pageNo: number): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/RecentActiviesDashboardApi/documentRecentActivities/' + data + '/' + itemsperpage + '/' + pageNo, { headers: header, observe: 'response' });
  }
  getFormDetails(formconfigname: string): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/FormDashboardApi/GetFormdetails/' + formconfigname.toLocaleLowerCase());
  };
  getdocumentRecentActivitiesforPagination(data: string, itemsperpage: number, pageNo: number): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/RecentActiviesDashboardApi/documentRecentActivities/' + data + '/' + itemsperpage + '/' + pageNo, { headers: header, observe: 'response' });

  }

  getdocumentRecentActivitiesCount(data: string): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/RecentActiviesDashboardApi/getdocumentRecentActivitiescount/' + data, { headers: header, observe: 'response' });

  }

}
